<template>
  <v-card flat>
    <v-row
      no-gutters
      class="px-4"
    >
      <v-col
        cols="12"
        class="px-3"
        :sm="12"
        :md="6"
      >
        <WBDOrganizationSelectorFilter
          :remote-list="remoteList"
          :selected-option-value="filteredOrgList"
          @onOrganizationListSelectorFilterChange="onOrganizationListSelectorFilterChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="12"
        :md="6"
      >
        <WBDRegionListSelectorFilter
          :filtered-laborer-list="''"
          :remote-list="[]"
          show-raw
          @onRegionListSelectorFilterChange="onRegionListSelectorFilterChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        :md="6"
      >
        <WBDProfessionSelectorFilter
          :remote-list="[]"
          :label="'Профессия'"
          :remote-selected-list-list="''"
          @onSelectedProfessionValueChange="onSelectedProfessionValueChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        :md="6"
      >
        <WBDLaborerActivationStatusSelectorFilter
          :remote-list="[]"
          :selected-option-value="''"
          :label="'Активирован'"
          @onSelectedLaborerActivationStatusValueChange="onSelectedLaborerActivationStatusValueChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :md="4"
        :sm="12"
      >
        <WBDVacancyStateSelectorFilter
          ref="vacancyStateSelectorFilterRef"
          :remote-list="[]"
          :label="'Состояние'"
          :remote-selected-list-list="''"
          @onVacancyStateStateChange="onVacancyStateStateChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="12"
        :md="8"
      >
        <WBSearchQueryFilter
          :remote-value="''"
          :label="'Поиск по названию'"
          @onSearchQueryFilterChange="onSearchQueryFilterChange"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>

import WBDOrganizationSelectorFilter from '@/components/common/filter/organization-selector-filter'
import WBDRegionListSelectorFilter from '@/components/common/filter/region-selector-filter'
import WBDProfessionSelectorFilter from '@/components/common/filter/profession-selector-filter'
import WBDVacancyStateSelectorFilter from '@/components/common/filter/vacancy-state-filter.vue'
import WBDLaborerActivationStatusSelectorFilter from
'@/components/common/filter/laborer-activation-status-selector-filter'
import WBSearchQueryFilter from '@/components/common/filter/search-query-filter.vue'
export default {
  name: 'WBDVacancyListPageFilter',
  components: {
    WBSearchQueryFilter,
    // WDatePicker,
    WBDOrganizationSelectorFilter,
    WBDLaborerActivationStatusSelectorFilter,
    WBDProfessionSelectorFilter,
    WBDRegionListSelectorFilter,
    WBDVacancyStateSelectorFilter,
  },
  props: {
    vacancyListFilterSet: {
      type: Object,
      default: () => ({
        region: null,
        searchQuery: null,
        organization: null,
        isActive: null,
        vacancyProfession: null,
        state: null,
      })
    }
  },
  data: () => ({
    searchQuery: '',
    filteredOrgList: '',
    remoteList: [],
    loading: true,
  }),
  computed: {
  },
  watch: {
    vacancyListFilterSet: {
      handler (val) {
        for (const [key, value] of Object.entries(val)) {
          if (this.vacancyListFilterSet[key] !== value) {
            this.vacancyListFilterSet[key] = value
          }
        }
      },
      deep: true,
    },
  },
  created () {
    this.eventsBus.$on(this.eventNames.VACANCY_PAGE_LIST_FILTER_RESET, () => {
      this.resetAll()
    })
  },
  methods: {
    onOrganizationListSelectorFilterChange (data, org) {
      this.vacancyListFilterSet.organization = org
    },
    onRegionListSelectorFilterChange (data) {
      this.vacancyListFilterSet.region = data
    },
    onSelectedProfessionValueChange (data) {
      this.vacancyListFilterSet.vacancyProfession = data
    },
    onVacancyStateStateChange (data) {
      this.vacancyListFilterSet.state = data
    },
    onSelectedLaborerActivationStatusValueChange (data) {
      this.vacancyListFilterSet.isActive = data
    },
    onSearchQueryFilterChange (data) {
      this.vacancyListFilterSet.searchQuery = data
    },
    async onClearFilter () {
      const refCollection = [
        'vacancyStateSelectorFilterRef',
      ]

      for (const refEntry of refCollection) {
        const currentRef = this.$refs[refEntry]
        if (currentRef) {
          console.log('onClearDistanceMinFilter')
          await currentRef.onClear()
        }
      }
    },
    resetAll () {
      this.onClearFilter()
      this.eventsBus.$emit(this.eventNames.ORG_LIST_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.REGION_LIST_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.PROFESSION_LIST_FILTER_RESET)
      this.eventsBus.$emit(this.eventNames.LABORER_ACTVATION_STATUS_FILTER_RESET)
    },
  }
}
</script>

